import { z } from "zod";

const EMAIL_REGEX_UNICODE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/u;
const PHONE_REGEX = /^\+[\d ]{7,15}$/;

const validationMessages = {
  nameTooShort: "nameTooShort",
  messageTooShort: "messageTooShort",
  invalidEmail: "invalidEmail",
  invalidPhone: "invalidPhone",
  invalidTourDate: "invalidTourDate",
  missingListing: "missingListing",
};

const baseContactSchema = z.object({
  fullName: z.string().min(2, { message: validationMessages.nameTooShort }),
  email: z
    .string()
    .regex(EMAIL_REGEX_UNICODE, { message: validationMessages.invalidEmail }),
  phoneNumber: z
    .string()
    .regex(PHONE_REGEX, { message: validationMessages.invalidPhone }),
  message: z.string().min(10, { message: validationMessages.messageTooShort }),
});

const baseMessageOnlySchema = z.object({
  message: z.string().min(10, { message: validationMessages.messageTooShort }),
});

export const generalContactSchema = baseContactSchema;
export const generalContactSchemaAuth = baseMessageOnlySchema;

export const listingContactSchema = baseContactSchema.extend({
  listingId: z.string().min(1, { message: validationMessages.missingListing }),
});
export const listingContactSchemaAuth = baseMessageOnlySchema.extend({
  listingId: z.string().min(1, { message: validationMessages.missingListing }),
});

export const locationContactSchema = baseContactSchema.extend({
  listingId: z.string().min(1, { message: validationMessages.missingListing }),
});
export const locationContactSchemaAuth = baseMessageOnlySchema.extend({
  listingId: z.string().min(1, { message: validationMessages.missingListing }),
});

export const tourContactSchema = baseContactSchema.extend({
  listingId: z.string().min(1, { message: validationMessages.missingListing }),
  tourDate: z.string().min(1, { message: validationMessages.invalidTourDate }),
});
export const tourContactSchemaAuth = z.object({
  tourDate: z.string().min(1, { message: validationMessages.invalidTourDate }),
  listingId: z.string().min(1, { message: validationMessages.missingListing }),
});
